<template>
  <div class="product-wrap">
    <!-- style="padding: 20px 30px 12px;" -->
    <grid-view style="padding: 0;">
      <template #tab>
        <div class="table-operator">
          <a-input-search
            style="width: 290px;"
            v-model="queryParam.text"
            allowClear
            placeholder="搜索文件名"
            @pressEnter="onSearch('0')"
            @search="onSearch('0')"
          />
          <p class="total">已全部加载，共{{ grid.page.total }}个</p>
        </div>
        <div class="bread-menu" style="margin-top: 24px; height: 21px;">
          <a-breadcrumb separator=">">
            <a-breadcrumb-item
              v-for="(item, index) in breadList"
              :key="item.value"
            >
              <a-button
                type="link"
                :class="item.disabled ? 'disabledBtn' : 'breadBtn'"
                :disabled="item.disabled"
                @click.prevent="linkBread(item.value, index)"
                :title="item.title"
              >
                {{
                  item.title.length > 20
                    ? item.title.slice(0, 20) + '...'
                    : item.title
                }}
              </a-button>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </div>
      </template>
      <template #grid>
        <!-- :scroll="{ y: '100%' }" -->
        <a-table
          class="product"
          ref="table"
          :columns="grid.columns"
          :pagination="grid.page.total > 40 ? grid.page.toGrid() : false"
          :data-source="grid.data"
          :rowKey="(record) => record.fileId"
          @change="handleGrid"
          :locale="local"
        >
          <template slot="name" slot-scope="name, record">
            <div class="filename">
              <span :style="{
                  cursor: record.type == '1' ? 'pointer' : 'default',
                  wordBreak: 'break-all',
                  color: '#222',
                }"
                :title="name"
                @click="openFile(record)" class="filename__base">
                <eco-icon
                  :name="record.fileIcon"
                  :size="24"
                  style="margin-right: 8px; vertical-align: sub;"
                ></eco-icon>
                {{ name }}
              </span>
              <span v-if="record.type == '0'" class="filename__extension" title="复制链接" @click="copyLink(record)">
                <eco-icon
                  name="copy-link"
                  :size="24"
                  style="margin-left: 8px; vertical-align: sub;"
                ></eco-icon>
              </span>
            </div>
          </template>
          <template slot="expireDate" slot-scope="text, record">
            <!-- <span v-if="!record.isExpire">永久有效</span> -->
            <span style="color: #222;">{{ text }}</span>
            <!-- <date-to-string v-else :date="moment(overDate)" /> -->
          </template>
          <template slot="action" slot-scope="text, record">
            <a
              v-if="record.type === '0'"
              @click.prevent="download(record, 'file')"
              style="color: #4771f8;"
            >
              下载
            </a>
            <a v-else style="color: #4771f8;">
              <span
                v-if="!record.isLoading"
                @click.prevent="download(record, 'folder')"
              >
                下载
              </span>
              <span v-else>
                <a-icon type="loading" /> 打包中...
              </span>
            </a>
          </template>
        </a-table>
      </template>
    </grid-view>
  </div>
</template>

<script>
import {
  getShareList,
  getRootFile,
  packFolderToZip,
  recordDownloadTimes
} from "@/request/product.js";
import {
  model,
  auth,
  env,
  router
} from "eco-cli";
import moment from 'moment';
import Empty from "@/components/Empty";
import Fingerprint2 from "fingerprintjs2";
const {
  Filter,
  Page,
  Sort
} = model;
// import dateToString from '@/views/components/OverDateToString';
// import Clipboard from 'clipboard';

export default {
  components: {
    Empty
  },
  data() {
    return {
      grid: {
        columns: [
          // {
          //   title: "序号",
          //   dataIndex: "",
          //   key: "rowIndex",
          //   width: 100,
          //   align: "center",
          //   customRender: function (t, r, index) {
          //     return parseInt(index) + 1;
          //   },
          // },
          {
            title: "文件名",
            align: "left",
            dataIndex: "fileName",
            sorter: true,
            ellipsis: true,
            scopedSlots: {
              customRender: 'name'
            }
          },
          {
            title: "大小",
            align: "left",
            width: 100,
            dataIndex: "fileSize",
            customRender: (text, record, index) => {
              return ( <span style = "color:#222;" >{{text}}</span>
              )
            }
          },
          {
            title: "共享时间",
            align: "left",
            width: 150,
            dataIndex: "shareDate",
            sorter: true,
            defaultSortOrder: 'descend',
            sortDirections: ['descend', 'ascend'],
            customRender: (text, record, index) => {
              return ( <span style = "color:#222;" > {{text}}</span>
              )
            }
          },
          {
            title: "到期时间",
            align: "left",
            width: 120,
            dataIndex: "expireDate",
            customRender: (text, record, index) => {
              return ( <span style = "color:#222;" > {{text}} </span>
              )
            }
            // sorter: true,
            // defaultSortOrder: 'descend',
            // sortDirections: ['descend', 'ascend'],
          },
          // {
          //   title: "共享人",
          //   align: "left",
          //   width: 150,
          //   dataIndex: "shareName"
          // },
          {
            title: "操作",
            dataIndex: "action",
            width: 70,
            align: "center",
            scopedSlots: {
              customRender: "action",
            },
          },
        ],
        filter: Filter.new(),
        data: [],
        sort: Sort.new({
          column: 'shareDate'
        }),
        page: Page.new({
          pageSize: '40'
        }),
      },
      text: '',
      queryParam: {
        text: '',
        dirId: '',
        type: '1'
      },
      hasData: false, // 是否有数据
      config: env.config(),
      breadList: [],
      userFigure: '', // 用户指纹
      fiveGB: 1024 * 1024 * 1024 * 5,
      empty: require('@/assets/product/empty.png'),
      loading: true,
      local: {
        emptyText: <Empty loading text="没有找到相应资源" style="padding-top: 84px;" />,
      },
    }
  },
  // components: {
  //   dateToString
  // },
  mounted() {
    this.grid.filter.set("dirId", this.queryParam.dirId);
    this.grid.filter.set("type", this.queryParam.type);
    this.getList(true);
    this.breadList.unshift({
      title: '全部共享文件',
      value: ''
    });
    this.loaduserFigure();
    this.$message.config({
      top: '400px', // 距离顶部
    });
    // this.getRoot();
  },
  methods: {
    moment,
    // 更新表格
    getList(resetPage = false) {
      this.local.emptyText = (
        <Empty text="暂无资源" loading style="padding-top: 84px;" />
      )
      getShareList({
        page: resetPage ? Page.new({
          pageSize: '40'
        }) : this.grid.page,
        sort: this.grid.sort,
        filter: this.grid.filter,
      }).then(({
        list,
        page
      }) => {
        this.grid.data = list.map((v) => Object.assign(v, {
          key: v.id
        }));
        this.grid.page = page;
      }).finally(()=> {
          this.local.emptyText = (
          <Empty text="暂无资源" style="padding-top: 84px;" />
        )
      });
    },

    handleGrid(pagination, filters, sorter) {
      this.grid.page = Page.fromGrid(pagination);
      if (sorter.order) {
        if (sorter.field === 'fileName') {
          sorter.field = 'name';
        }
        this.grid.sort = Sort.fromGrid(sorter);
      }
      this.getList();
    },

    onSearch(type) {
      if (this.breadList.length === 0) {
        this.breadList.unshift({
          title: '全部共享文件',
          value: '',
          disabled: false,
        });
      } else {
        this.breadList = this.breadList.slice(0, 1);
      }
      // console.log('this.breadList.splice', this.breadList);
      if (type === '0' && this.queryParam.text.trim()) {
        this.breadList.push({
          title: `搜索：${this.queryParam.text.trim()}`,
          value: '',
          disabled: true,
        })
      }
      if (type === '0' && !this.queryParam.text.trim()) {
        this.queryParam.type = '1';
        this.queryParam.dirId = '';
      } else {
        this.queryParam.type = type;
      }

      this.grid.filter.set("text", this.queryParam.text);
      this.grid.filter.set("dirId", this.queryParam.dirId);
      this.grid.filter.set("type", this.queryParam.type);
      this.getList(true);
    },

    // 打开文件夹
    openFile(item) {
      if (item.type == '0') {
        return
      } else {
        this.queryParam.type = '1'
        this.breadList = item.breadList;
        this.queryParam.dirId = item.fileId;
        this.breadList.unshift({
          title: '全部共享文件',
          value: '',
          disabled: false,
        });
        this.grid.filter.set("dirId", this.queryParam.dirId);
        this.grid.filter.set("type", this.queryParam.type);
        this.getList(true);
      }
    },

    // 复制链接
    copyLink(record) {
        const {
          client,
          dataId,
          userFigure
        } = {
          client: navigator.userAgent,
          dataId: record.fileId,
          userFigure: this.userFigure
        }
        // 埋点记录下载次数
        recordDownloadTimes({
          client,
          dataId,
          userFigure
        });

        const panelElement = document.createElement("textarea");
        let text = router.url.ftp(record.curPath);
        panelElement.innerText = text;
        document.body.appendChild(panelElement);
        panelElement.select();
        document.execCommand("copy");
        document.body.removeChild(panelElement);
        this.$message.success({
          content: "链接已复制成功，快去粘贴吧~"
        });
    },

    linkBread(fileId, index) {
      this.queryParam.type = '1'
      this.queryParam.dirId = fileId;
      this.breadList = this.breadList.slice(0, index + 1);
      this.grid.filter.set("dirId", this.queryParam.dirId);
      this.grid.filter.set("type", this.queryParam.type);
      this.getList(true);
    },

    loaduserFigure() {
      Fingerprint2.get((components) => {
        const values = components.map(function (component, index) {
          if (index === 0) {
            //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
            return component.value.replace(/\bNetType\/\w+\b/, "");
          }
          return component.value;
        });
        // 生成最终id
        this.userFigure = Fingerprint2.x64hash128(values.join(""), 31);
      });
    },

    download(record, type) {
      // console.log("record: ", record);
      const {
        client,
        dataId,
        userFigure
      } = {
        client: navigator.userAgent,
        dataId: record.fileId,
        userFigure: this.userFigure
      }

      if (type == 'file') {
        // 埋点记录下载次数
        recordDownloadTimes({
          client,
          dataId,
          userFigure
        });
        router.turn.ftp(record.curPath);

      } else {
        const hide = this.$message.loading({
          content: '正在打包中, 请稍候...', 
          duration: 0,
        });
        setTimeout(hide, 1000);
        record.isLoading = true;
        packFolderToZip(record.fileId).then(res => {
          if (res.size > this.fiveGB) {
            this.$message.destroy();
            record.isLoading = false;
            const h = this.$createElement;
            this.$info({
              title: '提示',
              icon: ()=> h('a-icon', {
                props: {
                  type: 'question-circle',
                },
                style: {
                  color: '#faad14'
                }
              }),
              // closable: true,
              content: h('div', {}, [
                // h('div',{
                //   style: {
                //     textAlign: 'center',
                //     marginBottom: '20px'
                //   }
                // }, [
                //   h('EcoIcon', {
                //     props:{
                //       name: 'i-document',
                //       size: '20',
                //     },
                //     style: {
                //       marginRight: '8px'
                //     }
                //   }),
                //   h('span',{
                //     // DOM 属性
                //     domProps: {
                //       innerHTML: `${record.fileName}`
                //     },
                //     style: {
                //       fontSize: '14px',
                //       color: '#222'
                //     }
                //   }),
                // ] ),
                h('p', {
                  domProps: {
                    innerHTML: '您下载的内容超过5G，为了保障下载过程顺畅，建议单个文件下载！'
                  },
                  style: {
                      fontSize: '14px',
                      color: 'rgba(0,0,0,.65)'
                    }
                }),
              ]),
              okText: "我知道了",
              centered: true,
              onOk() {},
            });
          } else {
            const url = this.config.file_origin + "eco-disk-server/sftp/download/" + res.md5;

            // 埋点记录下载次数
            recordDownloadTimes({
              client,
              dataId,
              userFigure
            });
            // console.log("url: ", url);
            window.open(url, "_self");
          }
        }).finally(() => {
          setTimeout(()=>{
            record.isLoading = false;
          }, 1000);
          // record.isLoading = false;
        })
      }
    },

    getRoot() {
      getRootFile().then((res) => {
        this.breadList.push({
          title: res.name,
          value: res.id
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.breadBtn {
  color: #222;
  margin: 0;
  padding: 0;
  cursor: pointer;

  &:hover {
    color: #4771f8;
  }
}

.disabledBtn {
  margin: 0;
  padding: 0;
  color: #222 !important;
  cursor: context-menu !important;
}

/* .table-operator {
  text-align: right;
  margin-top: 24px;
  float: right;
  margin-bottom: -16px;
} */
.table-operator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;

  .total {
    text-align: right;
    margin-bottom: 0px;
    font-size: 12px;
    font-weight: 400;
    color: #222222;
    line-height: 22px;
  }
}

.filename {
  display: flex;
  min-width: 0;
  .filename__base {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .filename__extension {
    flex-shrink: 0;
    cursor: pointer;
    &:hover {
      color: #4771f8;
    }
  }
}
</style>
<style scoped>
.product-wrap ::v-deep .ant-tabs-bar {
  border-bottom: 1px solid #e8e8e8 !important;
}

.table-operator ::v-deep .ant-input-affix-wrapper .ant-input {
  height: 36px;
}

.product .ant-table-thead > tr > th {
  background: #f6f8fc;
  padding: 8px 18px !important;
}

.product .ant-table-tbody > tr > td {
  border-bottom: 1px solid #e8ecf1;
  padding: 12px 18px;
}

.product .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
  background-color: #f7f9fd !important;
}

.product .ant-table-body .ant-table-row-hover {
  background: #f7f9fd !important;
}

.product .ant-table-body .ant-table-row-hover > td {
  background: #f7f9fd !important;
}

.product
  .ant-table-thead
  > tr
  > th
  .ant-table-column-sorter
  .ant-table-column-sorter-inner
  .ant-table-column-sorter-up.on,
.ant-table-thead
  > tr
  > th
  .ant-table-column-sorter
  .ant-table-column-sorter-inner
  .ant-table-column-sorter-down.on {
  color: #4771f8;
}

.product .ant-input-affix-wrapper .ant-input:focus {
  box-shadow: none;
  -webkit-box-shadow: none;
  border-color: #4771f8 !important;
}

.product .ant-input:hover {
  border-color: #4771f8;
  border-right-width: 1px !important;
}

.product .ant-pagination-item-active {
  background: #4771f8;
}

.product .ant-pagination-item-active:hover {
  background: #7398ff;
}

.product .ant-pagination-item-active a {
  color: #fff;
}
</style>
<style>
.product-wrap .ant-tooltip {
  max-width: 500px;
}
</style>
